/** Khuyến mãi nạp point — 19/10 → hết 20/10/2026 (giờ VN +07), tri ân Ngày Phụ nữ Việt Nam. */
export const TOPUP_PROMO_START_KEY = "2026-10-19";
export const TOPUP_PROMO_END_KEY = "2026-10-20";
/** @deprecated dùng START/END — giữ alias cho chỗ cũ nếu còn import */
export const TOPUP_PROMO_DATE_KEY = TOPUP_PROMO_END_KEY;
export const TOPUP_PROMO_EXTRA_BONUS = 0.2;
export const TOPUP_PROMO_TIMEZONE = "Asia/Ho_Chi_Minh";
export const TOPUP_PROMO_LABEL = "19/10 – 20/10/2026";
export const TOPUP_PROMO_THEME_LABEL = "Ngày Phụ nữ Việt Nam 20/10";

export function getVietnamDateKey(date: Date = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TOPUP_PROMO_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

export function isTopupPromoActive(date: Date = new Date()): boolean {
  const key = getVietnamDateKey(date);
  return key >= TOPUP_PROMO_START_KEY && key <= TOPUP_PROMO_END_KEY;
}
